angular.module("meanApp").config(($stateProvider) => {
  $stateProvider.state("login", {
    url: "/",
  });
});
